import { getMatter } from '@/api/client';
import { useAppStore } from '@/store';

/** NB-27 — make sure the app store holds this matter's full state
 * (claims with their key terms). Best-effort: a failure leaves the
 * page working without claim terms, as before. */
export async function ensureMatterState(matterId: string): Promise<void> {
  const app = useAppStore.getState();
  if (app.matterState?.matter?.id === matterId) return;
  try {
    const full = await getMatter(matterId);
    // The drafter may have moved on while this was in flight.
    if (useAppStore.getState().matterId && useAppStore.getState().matterId !== matterId) return;
    const fresh = !useAppStore.getState().matterState;
    useAppStore.getState().setMatterState(full);
    // Back from Drawings opens the matter where it is, as opening it
    // from the matter list does.
    if (fresh && full?.matter?.current_stage) {
      useAppStore.getState().setActiveStage(full.matter.current_stage);
    }
  } catch (e: unknown) {
    // eslint-disable-next-line no-console
    console.warn('drawing page: matter state load failed', e);
  }
}
